import { render, staticRenderFns } from "./GridLayoutsPopup.vue?vue&type=template&id=2604e2ae&"
import script from "./GridLayoutsPopup.vue?vue&type=script&lang=ts&"
export * from "./GridLayoutsPopup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports